var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrintReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2367_9180",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2367_9180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6V3.75H6V6H4.5V2.25H13.5V6H12ZM13.5 9.375C13.7125 9.375 13.8906 9.30313 14.0344 9.15938C14.1781 9.01563 14.25 8.8375 14.25 8.625C14.25 8.4125 14.1781 8.23437 14.0344 8.09062C13.8906 7.94687 13.7125 7.875 13.5 7.875C13.2875 7.875 13.1094 7.94687 12.9656 8.09062C12.8219 8.23437 12.75 8.4125 12.75 8.625C12.75 8.8375 12.8219 9.01563 12.9656 9.15938C13.1094 9.30313 13.2875 9.375 13.5 9.375ZM12 14.25V11.25H6V14.25H12ZM13.5 15.75H4.5V12.75H1.5V8.25C1.5 7.6125 1.71875 7.07813 2.15625 6.64688C2.59375 6.21563 3.125 6 3.75 6H14.25C14.8875 6 15.4219 6.21563 15.8531 6.64688C16.2844 7.07813 16.5 7.6125 16.5 8.25V12.75H13.5V15.75ZM15 11.25V8.25C15 8.0375 14.9281 7.85937 14.7844 7.71562C14.6406 7.57187 14.4625 7.5 14.25 7.5H3.75C3.5375 7.5 3.35938 7.57187 3.21563 7.71562C3.07188 7.85937 3 8.0375 3 8.25V11.25H4.5V9.75H13.5V11.25H15Z",
    fill: "url(#paint0_linear_2367_9180)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2367_9180",
    x1: 9,
    y1: 2.25,
    x2: 9,
    y2: 15.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.197917,
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA5FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintReport);
export default __webpack_public_path__ + "static/media/printReport.003776fc91b55b3bee8d774441387fe2.svg";
export { ForwardRef as ReactComponent };